export const COMMON_MSG = '请稍后再试，若有疑问请咨询福利鹅微信公众号客服～';
export const TIPS_MSG = {
  MOBILE_ORDERED: '当前手机号已订购过该流量包，请更换手机号再来', // 手机号已订购提示
  MOBILE_ORDERING: '您订购的流量包正在马不停蹄的备货中，请等待运营商短信通知。',
};

export const ERROR_MSG = {
  3: '太久无操作行为，请重新登录哦～',
  4: '操作过于频繁，请稍后再试',
  /** queryUserMobile */
  20001: '手机号格式不正确',
  /** packageList */
  20102: '活动太火爆，资格已耗尽',
  20103: '当前账号已订购过该流量包，请更换账号再来',
  20104: TIPS_MSG.MOBILE_ORDERED,
  201011: '当前账号已订购过该流量包，请更换账号再来',
  201012: TIPS_MSG.MOBILE_ORDERED,
  201013: '您没有参与活动的资格',
  201014: '您的手机号所属地区不支持订购',
  201015: '您的手机余额不足',
  201016: '您的手机号状态异常',
  201017: '您的手机号不支持订购',
  201018: '您本月没有参与活动的资格',
  201019: '您的手机余额不足或者状态异常',
  201020: '您已经订购不允许重复订购',
  201021: '携号转网用户不允许订购',
  201022: '您没有参与活动的资格',
  201023: '您的手机号所属的省份不支持订购',
  /** activateOrder */
  20201: '当前openId已存在有效订单',
  20202: '当前openId存在流程中订单',
  20203: '当前手机号存在流程中订单',
  20204: '查不到订单',
  /** orderPackage 错误码 */
  20301: '订购信息错误，请重试',
  20302: '当前手机号已经存在生效的流量包，请更换手机号或账号再来',
  20303: '手机号的运营商与该商品配置的运营商不一致',
  20304: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
  20305: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',

  /** orderSMSCode 错误码 */
  20401: '不支持的手机号段，只支持电信', // 非电信、移动用户调用申请验证码接口
  20402: '订购信息错误，请稍后重试', // `非法pId，不支持订购`,
  20403: '订购信息错误，请稍后重试', // `非法游戏编码，请运营检查游戏配置`,
  20901: '获取验证码频繁，请一分钟后再试', // `供应商接口调用错误`,
  20302: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
  20304: '当前手机号或账号已存在生效的流量包，请更换手机号或账号再来',
  201022: '您当前手机号暂不支持订购，如需了解具体原因，可致电号码归属运营商。',
  201028: '您当前手机号暂不支持订购，如需了解具体原因，可致电号码归属运营商。',
  202101: '账户余额不足',
  202102: '商品库存不足',
  202103: '该商品每月限兑换一次',
  202112: '超过用户商品总限',
  202113: '该商品每月限兑换一次',
  /** submitOrder 错误码  */
  20503: '验证码错误，请重新填写',
  20504: '验证码已过期，请重新发起申请',
  20502: '验证码已过期，请查收最新短信，重新填写',
  20501: '验证码错误，请重新填写',
  20506: '您的账号和已提交订单的账号不一致，无法订购，请更换账号再来',
  20505: '此手机号已订购该产品，请更换手机号尝试',
  20306: '此手机号已订购该产品，请更换手机号尝试',
  20901: COMMON_MSG,

  /** activeMobile */
  20205: '验证码错误，请重新填写',

  /** awardPrize */
  1000006: '您已经参与过啦，请次月再来～',
  1000115: '您已经参与过啦，请次月再来～',
  1000116: '您已经参与过啦，请次月再来～',
  1000117: '您已经参与过啦，请次月再来～',
  1000118: '您已经参与过啦，请次月再来～',
  1000105: '已领取该礼包请勿重复领取～',
  1000021: '非常抱歉，本轮限量奖励已被抽完',
  10001: '当前账号登录环境异常，请更换其他账号再试',
  10002: '活动太火爆了，请稍后重试',
  10003: '当前账号暂不具备活动参与资格，请更换其他账号再试',
  30202: '本月您已抽过奖啦，每类资格每月仅可消耗一次，您可下月再来继续参与活动~',
  30203: '您的订购时长已超出领奖期限，无法领奖，详情参见活动规则。如需领奖，请联系运营商客服退订后重新订购，可享更多礼包领取资格',
  10116: '操作频繁，请联系微信公众号《腾讯福利鹅》客服～',
  1000026: '操作频繁，请稍后再试',
  1000100: '该活动已结束，敬请期待下次～',
  1000103: '该活动尚未开始，敬请期待～',
  1000104: '该活动已结束，敬请期待下次～',
  1000007: '请勿重复签到',
  201029: '您没有参与活动的资格',
  1000114: '今日奖品已领完，请明天再领～',
  1000128: '今日奖品已领完，请明天再领～',
  1000113: '本周奖品已领完，请下周再领～',
  1000127: '本周奖品已领完，请下周再领～',
  1000112: '本月奖品已领完，请下月再领～',
  1000126: '本月奖品已领完，请下月再领～',
  1000111: '当前任务奖品已经领完~',
  1000125: '当前任务奖品已经领完~',
};

export const ORDER_SMS_CODE_ERROR_MSG = {
  4: '获取验证码频繁，请一分钟后再试',
  20901: '获取验证码频繁，请一分钟后再试', // `供应商接口调用错误`,
};

export const GOODS_ERROR_MSG = {
  1000105: '已提交地址请勿重复提交～',
  1000114: '今日奖品已领完，请明天再领～',
  1000128: '今日奖品已领完，请明天再领～',
  1000113: '本周奖品已领完，请下周再领～',
  1000127: '本周奖品已领完，请下周再领～',
  1000112: '本月奖品已领完，请下月再领～',
  1000126: '本月奖品已领完，请下月再领～',
  1000111: '当前任务奖品已经领完~',
  1000125: '当前任务奖品已经领完~',
};

export const ERROR_CODE = {
  NOT_CMCC_USER: 202201,
  SMS_CODE_ERROR: -100004,
  FREE_GIFT_RECEIVED_ERROR: -801,
  FREE_GIFT_HAS_RECEIVED: 202203,
  // 供应商返回错误
  SUPPLIER_ERROR: [20901, 20902],
  SMS_ERRORS: [20501, 20502, 20503, 20205],
};
